import { Check, X } from 'lucide-react';
import { PASSWORD_RULES } from '@/lib/passwordRules';
import './PasswordStrengthChecklist.scss';

interface Props {
  password: string;
  /** Optional surface modifier. Defaults to `light` (works on white cards).
   *  Use `dark` when the host surface is the dark auth panel — rules pick
   *  brighter `met` / `unmet` colours so the text reads on the dark canvas. */
  surface?: 'light' | 'dark';
}

/**
 * Inline checklist of password rules that toggles each row between met /
 * unmet as the user types. Mirrors `validatePasswordStrength` from
 * `@/lib/passwordRules` so what the user sees is what the BE will enforce.
 *
 * Pure render — no state of its own. Submit gating is the host form's
 * responsibility via `validatePasswordStrength`.
 */
export const PasswordStrengthChecklist = ({ password, surface = 'light' }: Props) => (
  <ul
    className={`pw-checklist pw-checklist--${surface}`}
    aria-live="polite"
  >
    {PASSWORD_RULES.map((rule) => {
      const met = rule.test(password);
      return (
        <li
          key={rule.label}
          className={met ? 'pw-checklist__rule pw-checklist__rule--met' : 'pw-checklist__rule'}
        >
          {met ? <Check size={12} aria-hidden="true" /> : <X size={12} aria-hidden="true" />}
          <span>{rule.label}</span>
        </li>
      );
    })}
  </ul>
);
